import { render } from "./App.vue?vue&type=template&id=5b973e40"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5b973e40&lang=css"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__